import styled from 'styled-components'

export const TooltipContainer = styled.div`
  position: absolute;
  pointer-events: none;
  transform: translate(-50%, -100%);
  z-index: 1000;
`

// Container for the entire MapTilesSearch component
export const MapTilesContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

// Hover feature tooltip positioning
export const HoverTooltip = styled.div<{
  $left: number
  $top: number
}>`
  position: absolute;
  left: ${({ $left }) => $left}px;
  top: ${({ $top }) => $top - 10}px;
  pointer-events: none;
  transform: translate(-50%, -100%);
  z-index: 1000;
`
